<template>
  <el-dialog
    visible
    :title="$t('COMMON_UPLOAD')"
    width="40%"
    :close-on-click-modal="false"
    append-to-body
    :before-close="handleClose">
    <div slot="title" class="title">
      <UploadTitleTips></UploadTitleTips>
    </div>
    <el-upload class="upload-drag"
               ref="uploadLog"
               :headers="headers"
               :on-remove="handleRemove"
               :data="{sourceId:matterLogId, siteId: getSite.siteId}"
               :show-file-list="false"
               :file-list="hereFilelist"
               :limit="limitNum"
               :on-progress="uploading"
               :on-change="uploadchange"
               :on-success="handleUploadSuccess"
               :before-upload="beforeFileUpload"
               :on-exceed="handleExceed"
               drag
               :action="actionUrl"
               :auto-upload="true"
               multiple>
      <i class="el-icon-upload"></i>
      <div class="el-upload__text" style="word-break: break-word;">{{$t('PAGE_PBC_UPLOAD_text1')}}<em> {{$t('PAGE_PBC_UPLOAD_text2')}}</em></div>
      <div class="el-upload__tip upload-rule-text">
        {{$t('PAGE_PBC_UPLOAD_TIP', {size: fileLimit})}}
      </div>
    </el-upload>
    <!--    上传文件列表-->
    <div class="overflow-fileList-container"  v-if="hereFilelist.length">
      <div v-for="hereFilelist in hereFilelist" :key="hereFilelist.uid">
        <div class="uploaded-cls">
          <span>{{ hereFilelist.name }}</span>
          <div v-if="hereFilelist.status === 'success'">
            <template>
              <i class="el-icon-circle-check uploaded-checked-cls" style="color: rgb(103, 194, 58)"></i>
              <i class="el-icon-delete del-uploaded-cls" @click="handleRemove(hereFilelist)" />
            </template>
          </div>
        </div>
        <div style="position: relative" class="progress-cls" v-if="hereFilelist.status === 'uploading'">
          <el-progress :percentage="parseInt(hereFilelist.percentage)" :stroke-width="3" :format="formatProgress" style="width: 95%;"></el-progress>
          <i v-if="hereFilelist.percentage===100" class="el-icon-loading loading-cls" />
          <i class="el-icon-delete del-cls" @click="removeUploading(hereFilelist)" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
  import {mapGetters} from 'vuex'
  import {checkIsValidExtension} from '@/utils/fileType'
  import {userPermission} from '@/mixins/userPermission.js'
  import API from '@/api'
  import requestUrl from '@/api/requestUrl'
  import UploadTitleTips from '@/components/common/UploadTitleTips.vue'

  export default {
    name: 'matterlogs-upload',
    components: { UploadTitleTips },
    props: {
      matterLogId: {type: String, default: ''},
      afterDelete: {
        type: Function, default: () => {
        }
      },
      afterUploadAllFinish: {
        type: Function, default: () => {
        }
      },
      initData: [String, Object],
    },
    mixins: [userPermission],
    data: () => ({
      onDrag: false,
      hereFilelist: [],
      // 文件上传数量限制，如果超过了限制数量，则会被从尾部切掉
      fileLimit: 100,
      notify: null,
      actionUrl: requestUrl('/client/clientMatterLog/uploadMatterFile'),
      headers: {},
    }),
    mounted() {
      this.headers = {
        Authorization: sessionStorage.getItem('JSESSIONID'),
        siteClassification: sessionStorage.getItem('siteClassification')
      }
    },
    methods: {
      handleClose() {
         
        let hereFilelist = this.hereFilelist.filter(item => item.status === 'ready' || item.status === 'uploading')
        if (hereFilelist.length > 0) {
          this.$confirm(this.$t('BEFORE_CLOSE_WARING_MSG'), this.$t('COMMON_TIP'), {
            confirmButtonText: this.$t('btn_confirm'),
            cancelButtonText: this.$t('btn_cancel'),
            type: 'warning'
          }).then(() => {
            hereFilelist.forEach(item => {
              this.$refs.uploadLog.abort(item)
            })
            this.afterUploadAllFinish()
          })
        } else {
          this.afterUploadAllFinish()
        }
      },
      uploading(event, file, files) {
        if (event.percent === 100 && this.notify == null) {
          this.notify = this.$message.warning({
            message: this.$t('upload_file_valid'),
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            onClose: () => {
              this.notify = null
            }
          });
        }
      },
      uploadchange(file, files) {
        if (file.status === 'success') {
        } else if(file.status !== 'fail') {
          this.hereFilelist.unshift(file)
        } else {
          // 上传失败，删除失败文件
          this.$message.error(file.name + this.$t('file_upload_failed'))
          let index = this.hereFilelist.findIndex((item) => item.name === file.name && item.uid === file.uid)
          if (index !== -1) {
            this.hereFilelist.splice(index, 1)
          }
        }
        if (this.hereFilelist.every(item => item.status === 'success' || item.status === 'fail') && this.notify !== null) {
          this.notify.close()
          this.notify = null
        }
      },
      handleUploadSuccess(res, file, files) {
        if (res.code !== '1') {
          this.$message.error(this.$t(res.code))
          // 上传失败
          let index = this.hereFilelist.findIndex(item => item.name === file.name && item.uid === file.uid)
          if (index !== -1) {
            this.hereFilelist.splice(index, 1)
          }
        }
      },
      beforeFileUpload(file) {
        if(this.scrollTimer) clearTimeout(this.scrollTimer)
        this.scrollTimer = setTimeout(() => {
          let overflow = document.querySelector('.overflow-fileList-container')
          overflow.scrollTop = overflow.scrollHeight
        }, 500)
        const isJPG = checkIsValidExtension(file.name);
        const isLt1G = file.size / 1024 / 1024 / 1024 < 1
        // 有50个不重名的文件则提示超出限制
        let uniqueNameFileList = []
        this.hereFilelist.forEach((v, k) => {
          if (!uniqueNameFileList.find((vv) => vv == v.name)) {
            uniqueNameFileList.push(v.name)
          }
        })
        const isFileList = (this.initData.attachmentList.length + uniqueNameFileList.length) <= this.fileLimit
        if (!isJPG) {
          clearTimeout(this.timer1)
          this.timer1 = setTimeout(() => {
            this.$message.error(this.$t('PAGE_MATTERLOG_UPLOAD_TYPE'))
          }, 100)
        } else if (!isLt1G) {
          clearTimeout(this.timer2)
          this.timer2 = setTimeout(() => {
            this.$message.error(this.$t('PAGE_PBC_UPLOAD_SIZE'))
          }, 100)
        } else if (!isFileList) {
          clearTimeout(this.timer3)
          this.timer3 = setTimeout(() => {
            this.$message.error(this.$t('PAGE_PBC_UPLOAD_LIMIT', {size: this.fileLimit}))
          }, 100)
        }
        // 移除不符合上传规则的文件
        if (!isJPG || !isLt1G || !isFileList) {
          let index = this.hereFilelist.findIndex(item => item.uid === file.uid)
          this.hereFilelist.splice(index, 1)
        }
        return isJPG && isLt1G && isFileList
      },
      handleRemove(file, fileList = []) {
        if (file.status === 'success') {
          const params = {
            mattterFileId: file.response.data,
            siteId: this.getSite.siteId
          }
          this.$confirm(this.$t('FILE_DELETE_WARNING_MSG_ONLY'), this.$t('COMMON_TIP'), {
            confirmButtonText: this.$t('btn_confirm'),
            cancelButtonText: this.$t('btn_cancel'),
            type: 'warning'
          }).then(() => {
            // 删除----
            API.matterLogs.deleteMatterSingleFile(params).then(res => {
              if (res.code !== '1') {
                return false
              } else if (res.code === '1') {
                let index = this.hereFilelist.findIndex(item => item.uid === file.uid)
                this.hereFilelist.splice(index, 1)
              }
            })
          })
        }
      },
      formatProgress(percentage) {
        return percentage === 100 ? '' : `${percentage}%`;
      },
      removeUploading(file) {
        this.$refs.uploadLog.abort(file)
        let index = this.hereFilelist.findIndex(item => item.uid === file.uid)
        this.hereFilelist.splice(index, 1)
        if (this.hereFilelist.every(item => item.status === 'success' || item.status === 'fail') && this.notify !== null) {
          this.notify.close()
          this.notify = null
        }
      },
      handleExceed(files, fileList) {
        this.$message.error(this.$t('PAGE_PBC_UPLOAD_LIMIT', {size: this.fileLimit}))
      },
    },
    beforeDestroy() {
      if (this.notify !== null) {
        this.notify.close()
        this.notify = null
      }
      if(this.scrollTimer) clearTimeout(this.scrollTimer)
    },
    computed: {
      ...mapGetters('common', {
        getUser: 'getUser',
        getSite: 'getSite'
      }),
      limitNum() { // 限制文件数为0的时候还可以上传，因此赋值为-1
        if(this.initData.attachmentList.length >= this.fileLimit) {
          return -1
        } else {
          return this.fileLimit - this.initData.attachmentList.length
        }
      },
      uploadBtnLoading() {
        return this.hereFilelist.some(v => v.status == 'processing')
      }
    }
  }
</script>
<style scoped>
.title {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.title .GuidanceTooltip {
    margin-left: 10px;
}
  ::v-deep .el-dialog__body {
    padding: 20px;
  }
  .upload-drag {
    width: 100%;
  }
  ::v-deep .upload-drag .el-upload-list {
    overflow: auto;
    max-height: 20vh;
  }
  ::v-deep .el-upload--text .el-upload-dragger{
    height: auto;
    padding: 20px;
  }
  ::v-deep .el-upload--text .el-upload-dragger .el-icon-upload {
    font-size: 50px;
    color: #3879eb;
    margin: 15px 0 15px;
    line-height: 50px;
  }
  .upload-rule-text{
    padding: 15PX 25PX;
    color: #81848a;
    margin-bottom: 15PX;
    font-size: 12PX;
  }
  .loading-cls{
    position: absolute;
    right: 24px;
    top: 0;
    color: rgb(64, 158, 255);
    cursor: pointer;
    font-size: 14px;
  }
  .del-cls{
    position: absolute;
    right: 0;
    top: 0;
    color: #fd349c;
    cursor: pointer;
    font-size: 14px;
  }
  .uploaded-cls{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .del-uploaded-cls {
    color: #fd349c;
    margin-left: 10px;
    font-size: 14px;
    cursor: pointer;
  }
  .uploaded-cls:hover{
    background-color: rgba(230, 230, 230, 0.5);
  }
  .uploaded-cls:hover .del-uploaded-cls {
    display: inline-block;
  }
  .overflow-fileList-container{
    max-height: 30vh;
    overflow: auto;
    height: 30vh
  }
</style>
